<script setup lang="ts">
import { UITextMdMedium } from '@gohighlevel/ghl-ui'
import { i18nLocale, useVueI18n } from '../../../locales'
import { CheckIcon } from '@gohighlevel/ghl-icons/24/outline'
import { UITag } from '@gohighlevel/ghl-ui'
import { formatDateWithLocale } from '../../../utils'

defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
})
const t = useVueI18n()
</script>

<template>
  <div class="flex items-center justify-between">
    <UITextMdMedium class="text-base">
      <span v-if="data?.metaData?.name" class="text-gray-800">
        {{ data.metaData.name }}
        <template v-if="data?.metaData?.email"
          >({{ data.metaData.email }})</template
        >
      </span>
      <span class="font-bold" v-else>{{ data.metaData.email }}</span>
      <span class="text-gray-500 ml-1">
        {{ t('proposalsList.eventLogs.acceptedTitle') }}
      </span>
    </UITextMdMedium>
  </div>
  <div class="flex justify-between items-end mt-3">
    <p class="text-md text-gray-500">
      {{
        formatDateWithLocale(
          data.createdAt,
          i18nLocale,
          'MMMM DD, YYYY'
        )
      }}
    </p>
    <UITag type="info" size="medium" class="text-[8px] approved-event">
      <template #icon> <CheckIcon class="w-4 h-4 check-icon" /></template>
      {{ t('proposalsList.eventLogs.accepted') }}
    </UITag>
  </div>
</template>

<style scoped lang="scss">
.approved-event {
  --n-text-color: rgb(194 65 12) !important;
  --n-color: rgb(255 247 237) !important;
  --n-border: 0px !important;
}
.check-icon {
  color: rgb(249 115 22) !important;
}
</style>
